export const TESTIDS = {
  loginUser: "login-username-input",
  loginPass: "login-password-input",
  loginSubmit: "login-submit-btn",
  navBriefing: "nav-briefing",
  navDashboard: "nav-dashboard",
  navPropales: "nav-propales",
  navClients: "nav-clients",
  navSettings: "nav-settings",
  logoutBtn: "logout-btn",
  importPropalesBtn: "import-propales-btn",
  importClientsBtn: "import-clients-btn",
  briefingCard: "briefing-action-card",
  copyMessageBtn: "copy-message-btn",
  actionRelance: "action-relance-btn",
  actionReporter: "action-reporter-btn",
  actionPerdu: "action-perdu-btn",
  actionSigne: "action-signe-btn",
  kpiEncours: "kpi-encours",
  kpiCaDormant: "kpi-ca-dormant",
  kpiPotentiel: "kpi-potentiel",
};
